<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="multiple"
    [formControl]="control"
    [compareWith]="compareById"
    [placeholder]="placeholder"
    [required]="required"
    panelClass="filter-select-panel"
    [matTooltip]="tooltip()"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    (closed)="onSelectionChange()">
    @if (multiple) {
      <mat-select-trigger>{{ summary() }}</mat-select-trigger>
    }

    @if (multiple && selectAllEnabled) {
      <mat-option #allItem [value]="allOption" (click)="onToggleItem(allOption, allItem.selected)">All</mat-option>
    }

    @for (option of options; track option.ID) {
      <mat-option #item [value]="option" (click)="onToggleItem(option, item.selected)">{{option.Description}}</mat-option>
    }

    @if (noneEnabled) {
      <mat-option #noneItem [value]="noneOption" (click)="onToggleItem(noneOption, noneItem.selected)">None</mat-option>
    }
  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>Selection is <strong>required</strong></mat-error>
  }
</mat-form-field>
